








































































import Vue from 'vue'
import { debounce } from 'debounce'
import ShortLink from '@/types/ShortLink.interface'
export default Vue.extend({
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        link: {
            type: Boolean,
            default: false
        },
        person: {
            type: Object,
            default: null
        },
        small: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            open: null,
            //  Determines if we were searching for a contact
            searched: false,
            //  Contains our temporary list of contacts
            searchResults: null,
            //  Holds the text in the searchbox
            searchtext: null
        }
    },
    computed: {
        // Function pulls from api to get the settings data table to see if a user is a2p enabled or not
        A2PRegistered(): boolean {
            const a2pEnabled = this.$store.getters.settingGet('a2pEnabled')

            // Ensure that the value isn't null, if it is we don't return it
            return a2pEnabled != null
        },
        messageLinks(): ShortLink[] {
            //  Links
            const links = this.$store.getters.messageLinks

            //  If we searched, return our search results
            if (this.searched) return this.searchResults
            //  Else, return the store getter
            else return links
        },
        //  The v-model for group member search text
        search: {
            get(): string {
                return this.searchtext
            },
            set: debounce(function (val: string): void {
                //  Set the searchtext state
                this.searchtext = val
                this.routesSearch()
            }, 750)
        }
    },
    methods: {
        onLinkPosted(link: boolean): void {
            this.open = false
            this.$emit('onLinkPosted', link)
        },
        onRouteSelected(route: ShortLink) {
            this.open = false
            this.$emit('onRouteSelected', route)
        },
        popRouteForm(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'short-link-popup',
                width: '670px',
                radius: '16px',
                props: {
                    person: this.person
                },
                closeable: true
            })
        },
        routeIcon(route: ShortLink): string {
            return (
                {
                    form: 'bi-ui-checks',
                    invoice: 'bi-cash',
                    web: 'bi-link'
                }[route.type] || 'bi-file-image-fill'
            )
        },
        async routesSearch(): Promise<void> {
            if (!this.searchtext) {
                //  Set to false so we display regular list
                this.searched = false
                //  Remove our search results
                return (this.searchResults = null)
            }

            //  Else grab our search text
            const text = this.searchtext

            //  Assemble our params for searching
            const params = { searchtext: text }

            //  Send the request
            const response = await this.$store.dispatch('routesSearch', params)

            //  SEt our search results
            this.searchResults = response || []

            //  Set searched to true so we display our list
            this.searched = true
        }
    }
})
